import { useAuthenticatedApi } from '@transport-insights/uikit';
import { useConfig } from '@src/context/config';

/**
 * @typedef {object} PortalNavContextResponse
 * @prop {NavContextDatabase[]} databases
 */

/**
 * @typedef {object} NavContextDatabase
 * @prop {string} id
 * @prop {string} name
 * @prop {string[]} lockYears
 */

/**
 * @param {import('./_backend').BackendSelector} backend
 */
export const useSettingsApi = () => {
  const { SETTINGS_API_URL } = useConfig();
  const api = useAuthenticatedApi(SETTINGS_API_URL);
  return {
    /**
     * @returns {Promise<PortalNavContextResponse>}
     */
    async getRcaSelectorState() {
      const res = await api.get('/rca-selector');
      return (res.data || {});
    },
    async setCurrentDatabase(databaseId) {
      await api.post(`/database?db=${databaseId}`);
    },
    async getNews() {
      const res = await api.get('news');
      return res?.data ?? [];
    },
    async setNewsViewed() {
      const res = await api.put('news/viewed', {});
      return res?.data ?? [];
    },
    async getConfig() {
      const res = await api.get('configs');
      return res?.data ?? {};
    },
    async getContent(contentType) {
      const res = await api.get(`/content/${contentType}`);
      return res?.data ?? null;
    },
    async getAdminContent(contentId) {
      const res = await api.get(`/content/articles/${contentId}`);
      return res?.data ?? null;
    },
    async createContentEntry(entry) {
      const res = await api.post('/content/articles', { ...entry }, {
        responseType: 'json',
      });
      return res?.data || null;
    },
    async updateContentEntry(entry) {
      const res = await api.put(`/content/articles/${entry.id}`, { ...entry }, {
        responseType: 'json',
      });
      return res?.data || null;
    },
    async deleteContentEntry(id) {
      const res = await api.delete(`/content/articles/${id}`);
      return res?.data || null;
    },
  };
};
